import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { commonRoutes } from 'constants/web-app-constants';
import { environment } from 'environments/environment';

@Component({
  selector: 'web-components-instrument-details-link',
  templateUrl: './instrument-details-link.component.html',
  imports: [RouterLink, NgTemplateOutlet],
})
export class InstrumentDetailsLinkComponent implements OnInit, OnChanges {
  @Input() public isin: string;
  @Input() public linkCssClass = 'text-color-primary';
  @Input() public queryParams: unknown = {};

  public url?: string;
  public isFeatureActive = environment.isInstrumentDetailFeatureActive;

  public ngOnChanges(): void {
    this.buildLink();
  }

  public ngOnInit(): void {
    this.buildLink();
  }

  private buildLink(): void {
    this.url = this.isFeatureActive
      ? `${commonRoutes.postlogin.instrument_detail}/${this.isin}`
      : `https://www.finanzen.net/go/${this.isin}`;
  }
}
